export default __webpack_public_path__ + "static/media/repossessions-of-chattels-mortgage.1341ea92.jpg";